import React from 'react';

const VideoPopup = props => {
  const { handleVideoPopup } = props;
  return (
    <div
      className="popup-box"
      id="popup-cover"
      onClick={e => {
        if (e.target.id === 'popup-cover') {
          handleVideoPopup(false, '');
        }
      }}
    >
      <div className="video-box">
        <span className="close-icon-video" onClick={() => handleVideoPopup(false, '')}>
          <svg width="20px" height="20px" className="svg-sprite label-close-icon-vid">
            <use href="/public/images/shapes.svg?v=#cancel-round" />
          </svg>
        </span>
        <iframe
          width="888"
          height="500"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen=""
          src="https://www.youtube.com/embed/iO_8rNiA1o0?autoplay=1"
        />
      </div>
    </div>
  );
};

export default VideoPopup;
